import type { AnnotatedJsonSchema } from '@web-config-app/core';
import { isCombinatorSchema } from '../is-combinator-schema/is-combinator-schema';

export const isCombinatorObjectSchema = (schema: AnnotatedJsonSchema) =>
  schema.type === 'object' && isCombinatorSchema(schema);
